import React, { useState, useContext } from "react";
import CreateView from "../Component/CreateView";
import { FileContext } from "../context/FileContext";
import { UploadMinimalistic } from "@solar-icons/react";
import { Magnifer } from "@solar-icons/react";
import { Tuning2 } from "@solar-icons/react";
import { DownloadMinimalistic } from "@solar-icons/react";
import { Bell } from "@solar-icons/react";
import { FaPlus } from "react-icons/fa6";
import { CloudFile } from "@solar-icons/react";
import { MoveToFolder } from "@solar-icons/react";
import { useEffect } from "react";
import { GoPlus } from "react-icons/go";
import { FaUser } from "react-icons/fa";
import { BsCreditCard } from "react-icons/bs";
import { MdNotificationsNone } from "react-icons/md";
import { FiLogOut } from "react-icons/fi";
import { useParams } from "react-router-dom";

const Header = () => {
  const {
    files,
    setFiles,
    progress,
    setProgress,
    isDownloading,
    setIsDownloading,
    search,
    setSearch,
  } = useContext(FileContext);

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [fileInput, setFileInput] = useState(null);
  const [fileType, setFileType] = useState("Folder");
  const [currentFolder, setCurrentFolder] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [bellOpen, setBellOpen] = useState(false);
  const [profileOpen,setProfileOpen] = useState(false);
  const menuRef = React.useRef(null);

 const { id } = useParams(); 
 console.log(id,'This is parent Id')

  const handleCreate = () => {
    const folderCount = files.filter((f) => f.FileType === "Folder").length + 1;
    const newFolder = {
      id: Date.now(),
      name: `New Folder ${folderCount}`,
      updatedAt: new Date().toLocaleString(),
      icon: "/assets/folder.png",
      FileType: "Folder",
      isDirectory: true,
      filecount: 0,
      items: [],
      parentId: id || null,
    };

    if (currentFolder) {
      currentFolder.items.unshift(newFolder);
      currentFolder.filecount += 1;
      setFiles([...files]);
    } else {
      setFiles([newFolder, ...files]);
    }

    setIsCreateModalOpen(false);
    setFileInput(null);
  };

  const handleDownload = async () => {
    const blobUrl =
      "https://<your-storage-account>.blob.core.windows.net/<container>/<filename>?<sas-token>";
    setIsDownloading(true);
    setProgress(0);

    try {
      const response = await fetch(blobUrl);
      if (!response.ok) throw new Error("Network response was not ok");

      const contentLength = response.headers.get("content-length");
      if (!contentLength) throw new Error("Content-Length not available");

      const total = parseInt(contentLength, 10);
      let loaded = 0;

      const reader = response.body.getReader();
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
        loaded += value.length;

        const percent = Math.round((loaded / total) * 100);
        setProgress(percent);
      }

      const blob = new Blob(chunks);
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = "filename.ext"; 
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Fetch download failed:", error);
    } finally {
      setIsDownloading(false);
    }
  };


  useEffect(() => {
  function handleClickOutside(e) {
    // If menu is open and click is outside both menu and profile image
    if (
      profileOpen &&
      menuRef.current &&
      !menuRef.current.contains(e.target) &&
      !e.target.closest(".avatar-btn")
    ) {
      setProfileOpen(false);
    }
  }

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [profileOpen]);





  return (
    <header className=" flex  py-4 bg-white shadow-md z-50 ">
         <div className="flex w-full gap-3">
           <div className="md:hidden flex items-center justify-center w-10 h-10 rounded-xl shadow hover:text-primary">
             <GoPlus
               fontSize={20}
               className="cursor-pointer"
               onClick={() => {
                 setIsCreateModalOpen(true);
                 setFileType("Folder");
                 setFileInput(null);
               }}
             />
           </div>
   
           <div className=" hidden ml-3 relative md:flex  md:w-full max-w-md ">
             <input
               type="text"
               placeholder="  "
               className="w-full rounded-xl  px-2 py-2  border text-[#6B6B6B] font-medium border-gray-300 bg-white "
             />
             <Magnifer
               fontSize={20}
               className=" absolute top-4 left-5 text-icon"
             />
           </div>
   
           <div className="hidden md:flex items-center gap-3  ">
             <div className="relative inline-block  hover:bg-third hover:text-primary  w-[170px]    rounded-xl ">
               <button
                 className="rounded-md font-medium px-4 py-2  text-lg w-full  border  hover:text-primary hover:bg-third text-icon flex items-center justify-center gap-2"
                 onClick={() => setMenuOpen((prev) => !prev)}
               >
                 <UploadMinimalistic className=" " fontSize={24} />
                 Upload
               </button>
   
               {menuOpen && (
                 <div className="absolute right-3 mt-2 bg-white rounded-2xl  w-[230px] h-[85px] border border-third p-2 z-10 flex flex-col justify-center">
                   <div
                     className="group flex items-center gap-3 text-lg font-medium text-secondary px-3 py-2 rounded-xl cursor-pointer hover:bg-third hover:text-primary transition"
                     onClick={() => {
                       setFileType("file");
                       setIsCreateModalOpen(true);
                       setMenuOpen(false);
                     }}
                   >
                     <CloudFile
                       className="text-icon group-hover:text-primary"
                       fontSize={24}
                     />
                     Upload File
                   </div>
                   <div className="group flex items-center gap-3   text-lg font-medium text-secondary px-3 py-2 rounded-xl cursor-pointer hover:bg-third hover:text-primary transition mt-1">
                     <MoveToFolder
                       className="text-icon group-hover:text-primary"
                       fontSize={24}
                     />
                     Upload Folder
                   </div>
                 </div>
               )}
             </div>
   
             <div className=" relative inline-block w-[170px] hover:bg-third  hover:text-primary  rounded-xl">
               <button
                 className=" rounded-md font-medium px-4 py-2 border text-lg  w-full hover:border-third hover:text-primary hover:bg-third text-icon flex items-center justify-center gap-2"
                 onClick={() => {
                   setIsCreateModalOpen(true);
                   setFileType("Folder");
                   setFileInput(null);
                 }}
               >
                 <GoPlus fontSize={24} className=" " />
                 Create
               </button>
             </div>
           </div>
         </div>
   
         <div className="relative hidden md:flex items-center justify-end gap-3 ml-auto pr-5  ">
           <div className=" w-12 h-12  border  flex items-center hover:border-none justify-center bg-white hover:bg-third  hover:text-primary rounded-xl">
             <DownloadMinimalistic
               className=" text-icon hover:text-primary hover:bg-third "
               fontSize={25}
             />
           </div>
   
           <div
             className="w-12 h-12 relative  border  hover:border-none flex items-center justify-center bg-white hover:bg-third  hover:text-primary rounded-xl"
             onClick={() => setBellOpen(!bellOpen)}
           >
             <Bell
               className=" text-icon hover:text-primary hover:bg-third "
               fontSize={25}
             />
           </div>
           <div className="w-12 h-12 border  rounded-xl flex items-center justify-center bg-white ">
             <img
               src="/assets/logo.png"
               alt="Azero"
               className="w-full h-auto object-contain rounded-xl "
               onClick={() => setProfileOpen(!profileOpen)}
             />
           </div>
         </div>
   
         {bellOpen && (
           <div className="absolute right-10 top-16 bg-white rounded-2xl w-[230px] h-[90px] border border-third p-4  ">
             <div className=" flex justify-center items-center font-medium  ">
               <span className=" font-medium text-[8px]">Account</span>
             </div>
             <div className="flex items-center gap-2   ">
               <div className=" w-5 h-5 ">
                 <img
                   src="/assets/Ellipse 5.png"
                   alt="Profile"
                   className=" rounded-full object-cover"
                 />
               </div>
               <div className=" flex flex-col">
                 <p className="font-medium text-secondary text-xs">Madesh</p>
                 <span className="text-[10px] text-gray-500">m@gmail.com</span>
               </div>
             </div>
   
             <div className=" flex justify-end">
               <button className=" px-2 py-1 border text-secondary rounded-md text-[8px] font-medium ">
                 Logout
               </button>
             </div>
           </div>
         )}
   
         {profileOpen && (
           <div
             className="absolute right-4 top-16 w-72 bg-white shadow-lg rounded-2xl border border-gray-200 p-5 animate-profileMenu"
             ref={menuRef}
           >
             <div className="flex flex-col items-center gap-2 pb-4 border-b">
               <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center shadow">
                 <img
                   src="/assets/logo.png"
                   alt="logo"
                   className="w-14 h-14 object-contain"
                 />
               </div>
   
               {/* User email */}
               <p className="text-sm font-medium text-gray-700">s@gmail.com</p>
             </div>
   
             {/* Menu */}
             <div className="mt-4 space-y-2">
               <button className="flex items-center w-full gap-3 p-2 rounded-xl hover:bg-gray-100 transition">
                 <FaUser className="text-gray-600" />
                 <span className="text-gray-700 font-medium">Account</span>
               </button>
   
               <button className="flex items-center w-full gap-3 p-2 rounded-xl hover:bg-gray-100 transition">
                 <BsCreditCard className="text-gray-600" />
                 <span className="text-gray-700 font-medium">Billing</span>
               </button>
   
               <button className="flex items-center w-full gap-3 p-2 rounded-xl hover:bg-gray-100 transition">
                 <MdNotificationsNone className="text-gray-600" />
                 <span className="text-gray-700 font-medium">Notifications</span>
               </button>
             </div>
   
             {/* Logout */}
             <div className="mt-4 pt-3 border-t">
               <button className="flex items-center w-full gap-3 p-2 rounded-xl text-red-500 hover:bg-red-50 transition">
                 <FiLogOut />
                 <span className="font-medium">Log out</span>
               </button>
             </div>
           </div>
         )}

          {isCreateModalOpen && (
        <CreateView
          files={files}
          setFiles={setFiles}
          currentFolder={currentFolder}
          setIsCreateModalOpen={setIsCreateModalOpen}
          fileType={fileType}
          setFileType={setFileType}
          fileInput={fileInput}
          setFileInput={setFileInput}
          handleCreate={handleCreate}
          isLoading={false}
           parentId={id || null} 
        />
      )}
       </header>
  );
};

export default Header;
